import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { GlobalFormats } from '../../classess/main/globalFormats';
import { Customer } from '../../classess/customer/customer';
import moment from 'moment';

import CustomerAddEditDetails from './CustomerAddEditDetails';
import {
    LoadingSection, badgetStatusGeneric, getProcessButtons, dataTableLanguaje, getDtRowIndex,
    handleResponseMessageAsync, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, settings, styles,
    awaitDelayAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { CustomerService } from '../../services/customers/CustomerService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const currentMethod = 'Customers';

const { html, colors, icons, images, labels, messages, } = settings;

export default function Customers({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtCustomersId = 'dtCustomers';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
        edit: false,
        delete: false,
        external: false,
    });
    const isMount = useRef(true);
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtCustomersId: dtCustomersId,
        dtCustomersRowId: 0,
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
            externalInfo: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnExternalInfo',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
            externalInfo: {
                id: 'iconExternalInfo',
                defaultClass: icons?.fasFa?.dataBase,
            },
        },
    };
    //#endregion methods

    //#region methods
    //#region customers
    const getAddCustomer = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddCustomer';
        try {
            if (e) e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: true,
            }));

            setCustomer(prev => ({
                ...Customer?.getClass({}, false),
                registerDate: moment(new Date())?.format(`${modalObj?.languageObj?.format?.date?.f13} ${modalObj?.languageObj?.format?.time?.f2}`),
            }));

            await awaitDelayAsync({ delayTime: settings?.timers?.oneSecond });

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getEditDetailsCustomer = async ({
        e = undefined,
        id = '',
        description = '',
        rowId = '',
        processType = 1,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditDetailsCustomer';
        try {
            if (e) e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
            }));

            response = await CustomerService.getById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const customerData = (response?.result?.customer?.id > 0) ?
                Customer?.getClass(response?.result.customer, false) :
                {};

            if (!customerData?.id) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`,
                });
                return;
            }

            setCustomer(prev => ({ ...Customer?.getClass(customerData, false) }));
            setModalObj(prev => ({
                ...prev,
                $: $,
                type: processType,
                auth: auth,
                showModal: true,
                dtCustomersRowId: rowId,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const deleteCustomer = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteCustomer';
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.customer?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: msgTextObj?.two,
                            showConfirmButton: false,
                        });

                        //#region delete data (customer)
                        preConfirmResponse = await CustomerService.deleteAsync({
                            auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (customer)

                        //#region delete datatable (customer)
                        $(`#${dtCustomersId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                        //#endregion delete datatable (customer)
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    } finally {
                        // Helper v2.2: Silent inside Swal
                    }
                    return preConfirmResponse;
                },
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                }
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
        return response;
    }

    const getCustomersExternalInfo = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getCustomersExternalInfo';
        try {
            setProcess(prev => ({ ...prev, showLoading: true, external: true, }));
            await awaitDelayAsync({ delayTime: settings?.timers?.oneSecond });
            setProcess(prev => ({ ...prev, showLoading: false, external: false, }));

            if (e) e?.preventDefault?.();
            const msgTextObj = {
                one: `${messages?.doYouWantToUpdateCustomers[languageObj?.id]}`,
                two: messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id],
                three: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: msgTextObj?.two,
                timer: null,
                confirmButtonColor: colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: msgTextObj?.three,
                            html: `${labels?.customers?.[languageObj?.id]}.`,
                            showConfirmButton: false,
                        });

                        preConfirmResponse = await CustomerService.externalInfoAsync({
                            auth,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        let msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.<br/>`;
                        msgText += `${labels?.createds[languageObj?.id]}: <b>${preConfirmResponse?.result?.resume?.create}</b><br/>`;
                        msgText += `${labels?.editeds[languageObj?.id]}: <b>${preConfirmResponse?.result?.resume?.update}</b><br/>`;
                        msgText += `${labels?.total[languageObj?.id]}: <b>${preConfirmResponse?.result?.customers?.length}</b>`;

                        preConfirmResponse.msgText = msgText;
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    } finally {
                        // Helper v2.2: Silent inside Swal
                    }
                    return preConfirmResponse;
                },
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                }
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
                if (response?.isSuccess && !response?.isWarning) {
                    await getData({
                        subMethod: currentMethod,
                    });
                }
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                external: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion customers

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: false,
            }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (customers)
                response = await CustomerService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const customers = response?.result?.customers || [];
                //#endregion get data (customers)

                //#region set datatable
                if (!isUndNullEmp({ data: customers, subMethod: currentMethod })?.result &&
                    customers.length > 0) {
                    response = setDataInDataTable({
                        data: customers,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                if (!response?.isSuccess) {
                    setShowData(false);
                }

                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
        return response;
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtCustomersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.code[languageObj?.id], width: '10%', },
                    { title: labels?.description?.[languageObj?.id], width: '49%', },
                    { title: labels?.rif?.[languageObj?.id], width: '13%', className: '', },
                    { title: labels?.nit[languageObj?.id], width: '13%', className: '', },
                    { title: labels?.enabled?.[languageObj?.id], width: '10%', className: 'text-center', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtCustomersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // Helper v2.2: Silent
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region process
            $(`#${dtCustomersId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtCustomersId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    // const attribute = e?.target?.attributes?.method;
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditDetailsCustomer({
                                e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                processType: 1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'details':
                            getEditDetailsCustomer({
                                e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                processType: 2,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            deleteCustomer({
                                e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // Helper v2.2: Silent
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables

            let customersDt = [];

            //#endregion variables

            //#region process
            data.forEach((customer) => {
                const modelCustomer = Customer?.getClass(customer, false);
                const processButtons = [
                    // {
                    //     isVisible: true,
                    //     showDivider: true,
                    //     isEnabled: true,
                    //     methodName: 'getExcel',
                    //     icon: icons?.fileExcelFas,
                    //     label: `${labels?.getExcel[languageObj?.id]}`
                    // },
                ];
                customersDt.push([
                    modelCustomer.secundaryId,
                    modelCustomer.name,
                    modelCustomer.rif,
                    modelCustomer.nit,
                    badgetStatusGeneric({
                        type: modelCustomer.isAvailable ? 0 : 5,
                        value: modelCustomer.isAvailable ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id],
                    }),
                    getProcessButtons({
                        id: modelCustomer.id,
                        description: modelCustomer.name,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: true,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtCustomersId}`)?.DataTable()?.rows?.add(customersDt)?.draw(true);

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // Helper v2.2: Silent
        }
        return response;
    }


    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'forma - onLoad', });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.customers.customers} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.customers?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.customers?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.customers?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.customers}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.customers?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.user} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            style={{ borderRadius: '5px' }}
                                                            className={controls?.buttons?.addEditDetails?.defaultClass}
                                                            disabled={process?.add}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => getAddCustomer({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={`${controls?.icons?.addEditDetails?.defaultClass}`} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                        <button id={controls?.buttons?.externalInfo?.id}
                                                            type='button'
                                                            style={{ borderRadius: '5px' }}
                                                            className={controls?.buttons?.externalInfo?.defaultClass}
                                                            disabled={process?.external}
                                                            title={labels?.updateCustomers?.[languageObj?.id]}
                                                            onClick={(e) => getCustomersExternalInfo({ e: e, subMethod: controls?.buttons?.externalInfo?.id })}>
                                                            {process?.external ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.externalInfo?.id} className={`${controls?.icons?.externalInfo?.defaultClass}`} />
                                                            )} {labels?.updateCustomersAbr?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtCustomersId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <CustomerAddEditDetails auth={auth}
                    modalObj={modalObj}
                    setModalObj={setModalObj}
                    customer={customer}
                    setCustomer={setCustomer} />
            )
            }
        </div>
    )
}